<div class="container-fluid">
	<div class="col-md-12" *ngIf="isLoading">
		<app-busy [message]="message"></app-busy>
	</div>
	<div class="page_header">
		<h1 class="heading">
			Manage {{this.lblHeading}}
		</h1>
	</div>
	<div class="row">
		<div *ngIf="isRemove" class="text-danger col-md-12">
			<input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
			<button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
			<button class="btn btn-default btn-sm" (click)="onNo()" style="width:80px;">No</button>
		</div>
		<div class="col-md-12" *ngIf="!isRemove">
			<div class="table-responsive">
				<table id="vTypes" border="1" class="table tbl-stl custom_table">
					<thead class="thead-inverse hgt-btn">
						<tr style="vertical-align:middle; font-size:14px;" class="hgt-btn">
							<th class="bfr-end-col">
								Device Id <i style="vertical-align:middle; " class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
									(click)="utility.onSort(1)"></i>
							</th>
							<th class="bfr-end-col">
								Scanner Alias
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
									(click)="utility.onSort(2)"></i>
							</th>
							<th class="bfr-end-col">Scanner IP
								Address
							</th>
							<th class="bfr-end-col">Current PC
							</th>
							<th class="btn-show hgt-btn bfr-end-col text-center"
								style="width:110px !important;padding:1px 0;">
								<a [routerLink]="['/scanner/add']" title="" style="" class="">
									<span title="Add a New Scanner" class=" btn-add btn btn-primary btn-sm"><i
											class="fa fa-plus fa-2x" aria-hidden="true"></i></span>
								</a>
							</th>

						</tr>
					</thead>
					<tr 
						*ngFor="let vType of vTypes  | orderBy: utility.criteria : utility.direction | paginate: { itemsPerPage: showNum, currentPage: utility.page }">
						<td class="bfr-end-col">{{vType.device_id}}</td>
						<td class="bfr-end-col">{{vType.scanner_alias}}</td>
						<td class="bfr-end-col">{{vType.scanner_ip_address}}</td>
						<td class="bfr-end-col">{{vType.pc_ip_address}}</td>
						<!-- <td class="bfr-end-col">{{vType.status.code}}</td>          -->
						<td class="btn-show bfr-end-col text-center" >
							<div class="actions_wrap">
								<a [routerLink]="['/scanner/edit',vType.id]"><span title="Edit Scanner"
									class="btn btn-success btn-sm"><i class="fa fa-pencil fa-fw"></i></span></a>
								<span title="Delete Scanner" class="btn btn-danger btn-sm" style="margin-left: 8px;"
									(click)="onConfirm(vType)"><i class="fa fa-trash-o fa-fw"></i></span>
							</div>
						</td>
					</tr>
					<tfoot>
						<tr *ngIf="vTypes.length > 4" class="pagination_row">
							<td colspan="8" class="rm-brd">
								<div class="row">
									<div class="col-4">
										<div class="input-group mb-3 rm-brd"
											style="width:125px!important;height:30px!important;">
											<div class="input-group-prepend">
												<label class="input-group-text form-control-sm show-h" for="show-id"
													>Show:</label>
											</div>
											<select class="form-control form-control-sm show-h" id="show-id"
												[(ngModel)]="showNum">
												<option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}
												</option>
											</select>
										</div>
									</div>
									<div class="col-8 text-right">
										<pagination-controls (pageChange)="utility.page = $event"></pagination-controls>
									</div>
								</div>
							</td>
						</tr>
						<tr *ngIf="isEmpty">
							<td colspan="5" class="rm-brd">
								<span class="text-info text-small">No scanners found.</span>
							</td>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
	</div>
</div>